import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS, SERVICES, CONTACT, SOCIALS } from "../data/site";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="grain relative bg-[#161616] text-neutral-300"
  >
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-12 md:px-8 md:py-24">
      <div className="md:col-span-5">
        <img
          src="/images/abs-logo-mark-dark-bg.png"
          alt="ABS LLC — Alex Brosseau Services"
          width="600"
          height="202"
          className="h-14 w-auto"
          loading="lazy"
        />
        <p className="font-overline mt-2 text-[10px] uppercase tracking-[0.3em] text-neutral-500">
          Alex Brosseau Services LLC
        </p>
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-neutral-400">
          Motorsport concierge and race operations support for amateur and
          semi-professional drivers across North America. You drive — we handle
          everything else.
        </p>

        <div data-testid="footer-socials" className="mt-10">
          <p className="font-overline text-[10px] uppercase tracking-[0.3em] text-neutral-500">Follow ABS</p>
          <ul className="mt-4 space-y-3">
            {SOCIALS.map((s) => (
              <li key={s.name}>
                <a
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.aria}
                  title={s.label}
                  data-testid={`footer-social-${s.name.toLowerCase()}`}
                  className="group flex min-h-[44px] items-center gap-3 text-sm text-neutral-400 transition-colors duration-300 hover:text-white"
                >
                  <span className="flex h-10 w-10 items-center justify-center border border-neutral-700 transition-colors duration-300 group-hover:border-[#e63946] group-hover:text-[#e63946]">
                    <s.icon className="h-4 w-4" />
                  </span>
                  <span>
                    <span className="block font-semibold text-neutral-300 transition-colors duration-300 group-hover:text-white">{s.name}</span>
                    <span className="block text-xs text-neutral-500">{s.label}</span>
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="md:col-span-3">
        <p className="font-overline text-[10px] uppercase tracking-[0.3em] text-neutral-500">Navigate</p>
        <ul className="mt-5 space-y-3">
          {NAV_LINKS.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="text-sm text-neutral-400 transition-colors duration-300 hover:text-white"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-2">
        <p className="font-overline text-[10px] uppercase tracking-[0.3em] text-neutral-500">Services</p>
        <ul className="mt-5 space-y-3">
          {SERVICES.map((s) => (
            <li key={s.num} className="text-sm leading-snug text-neutral-400">
              {s.title}
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-2">
        <p className="font-overline text-[10px] uppercase tracking-[0.3em] text-neutral-500">Contact</p>
        <ul className="mt-5 space-y-3 text-sm text-neutral-400">
          <li>
            <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="transition-colors duration-300 hover:text-white">
              {CONTACT.email}
            </a>
          </li>
          <li>{CONTACT.baseUS}</li>
          <li>{CONTACT.baseCA}</li>
          <li>
            <Link
              to="/contact"
              data-testid="footer-inquiry-link"
              className="group inline-flex items-center gap-1.5 font-semibold text-white transition-colors duration-300 hover:text-[#e63946]"
            >
              Start an inquiry
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </li>
          <li>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="text-xs text-neutral-500 transition-colors duration-300 hover:text-white"
            >
              Team sign-in
            </Link>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-neutral-800">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-neutral-500 md:flex-row md:items-center md:justify-between md:px-8">
        <p>© 2026 Alex Brosseau Services LLC. All rights reserved.</p>
        <p className="font-overline text-[9px] uppercase tracking-[0.3em]">Motorsport Concierge — North America</p>
      </div>
    </div>
  </footer>
);
